import fondoAsamblea from "../assets/imgs/fondoAsambleaHorizontal.webp";
import logoHorizontal from "../assets/imgs/logoAsambleaHorizontal.webp";
import logoAsamblea from "../assets/imgs/logoAsamblea.webp";
import panorama from "../assets/imgs/splashScreen/panorama.jpg";

const CRITICAL_IMAGES = [
  panorama,
  logoHorizontal,
  logoAsamblea,
  fondoAsamblea,
];

export function preloadCriticalImages() {
  CRITICAL_IMAGES.forEach((src) => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = src;
    document.head.appendChild(link);
  });
}
